__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "crew-scheduler-timeline";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@ant-design/icons", "5.3.0", function() { return Promise.all([__webpack_require__.e(995), __webpack_require__.e(896), __webpack_require__.e(20), __webpack_require__.e(7)]).then(function() { return function() { return __webpack_require__(3896); }; }); });
			register("antd", "5.14.2", function() { return Promise.all([__webpack_require__.e(995), __webpack_require__.e(691), __webpack_require__.e(574), __webpack_require__.e(20), __webpack_require__.e(216)]).then(function() { return function() { return __webpack_require__(5691); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(950), __webpack_require__.e(20)]).then(function() { return function() { return __webpack_require__(7950); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(43).then(function() { return function() { return __webpack_require__(5043); }; }); });
			initExternal(890);
			initExternal(6842);
			initExternal(3867);
			initExternal(5372);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};